// extracted by mini-css-extract-plugin
export default {"cell":"QfrfFD"};